import BlendedCareRepository from '@/services/BlendedCareRepository';

export default {
  async mounted() {
    if (!_.size(this.$store.state.subjects)) {
      await this.getListSubject();
    }
  },
  methods: {
    async getListSubject() {
      const response = await BlendedCareRepository.getSubjectDuo();
      if (response.message === 'Success') {
        this.$store.commit('SET_SUBJECTS', response.data);
      }
    },
    getSubjectById(id) {
      return this.$store.state.subjects.find((e) => e.id === id) || {};
    },
    getSubjectByName(name) {
      return this.$store.state.subjects.find((e) => e.name === name) || {};
    },
  },
};
